import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";
import { Typography, TypographyProps } from "@mui/material";

interface IProps extends TypographyProps {
  label: string;
}

const FieldLabel: React.FC<IProps> = ({ label, ...props }) => {
  return (
    <Typography
      variant="subtitle1"
      component="label"
      display="block"
      fontWeight={700}
      fontFamily={{ xs: FONT_SECONDARY, md: FONT_PRIMARY }}
      {...props}
    >
      {label}
    </Typography>
  );
};

export default FieldLabel;
